import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Grid, Button } from '@mui/material';
import { Page, CustomizedDialogs } from 'components';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
	root: {
	},
	content: {
		width: theme.breakpoints.values.md,
		maxWidth: '100%',
		margin: '0 auto',
		padding: '80px 24px',
		[theme.breakpoints.up('md')]: {
			padding: '160px 24px',
		},
	},
}));

const Home = () => {
	const classes = useStyles();
	const user = useSelector((state) => state.session.user);

	const searchString = 'ran';
	const searchString2 = 'client';

	const containsString = (user.projects?.some(
		project => project.toLowerCase().trim() === searchString.trim().toLowerCase()
	)) || false;

	const [open, setOpen] = React.useState(containsString);

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Page className={classes.root} title="Home">
			{/* <Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					Attention, user
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Please be informed that the portal will be discontinued as of September 1, 2024.
						Please prepare for this change and contact BT Line Manager for more information or support.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Close</Button>
				</DialogActions>
			</Dialog> */}
			<CustomizedDialogs />
			<div className={classes.content}>
				<Grid
					alignItems="center"
					className={classes.statsInner}
					container
					justifyContent="center"
					spacing={3}
				>
					<Grid item lg={6} md={6} xs={12}>
						<Typography align="center" gutterBottom variant="h1">
							Customer focus
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							We only find success in our customer’s success.
						</Typography>
					</Grid>
					<Grid item lg={6} md={6} xs={12}>
						<Typography align="center" gutterBottom variant="h1">
							Excellence
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							Our clients know that we pursue nothing less than the highest quality standards in everything we do.
						</Typography>
					</Grid>
					<Grid item lg={6} md={6} xs={12}>
						<Typography align="center" gutterBottom variant="h1">
							Collaboration
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							Our passion for teamwork leads to innovation, high level of effectiveness and continuous learning and improvement.
						</Typography>
					</Grid>
					<Grid item lg={6} md={6} xs={12}>
						<Typography align="center" gutterBottom variant="h1">
							Accountability
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							People who are not afraid to get their ideas off the ground are also proud to be held accountable for their results.
						</Typography>
					</Grid>
					<Grid item lg={6} md={6} xs={12}>
						<Typography align="center" gutterBottom variant="h1">
							Passion
						</Typography>
						<Typography align="center" component="h2" variant="subtitle1">
							Our passion is what keeps us relentlessly pushing for numerous game-changing innovations.
						</Typography>
					</Grid>
				</Grid>
			</div>
		</Page>
	);
};

export default Home;
